import userApi from '@/common/api/user';

let page = 1;

export default {
    data() {
        return {
            infoShow: false,
            genre: [], // 初始为空，mounted时初始化
            stateOption: [],
            coinList: [],
            modalShow: false,
            account : 1,
            size:15,
            start_at :"",
            end_at : "",
            currency_id : 0,
            type:0,
            types:[],
            logList:[],
            total : 0,
            timeValue:[],
            selectedType: '', // 当前选中的类型
            selectedCurrency: '', // 当前选中的币种
            selectedStatus: '' // 当前选中的状态
        }
    },
    mounted() {
        page = 1;
        this.initializeOptions();
        this.getLogList();
    },
    computed: {
        // 分页器总数显示文本
        paginationText() {
            if (this.$i18n && this.$i18n.locale === 'en-US') {
                return `Total ${this.total} items`;
            }
            return `共 ${this.total} 条`;
        }
    },
    watch: {
        // 监听语言变化
        '$i18n.locale'() {
            this.initializeOptions();
        }
    },
    methods:{
        // 初始化选项的多语言数据
        initializeOptions() {
            if (!this.$t) return; // 如果$t还没有准备好，直接返回
            
            // 流水类型选项 - 根据账户类型动态设置
            if (this.account === 1) { // 资金账户
                this.genre = [
                    'assets.all',
                    'assets.deposit',
                    'assets.withdraw',
                    'assets.transfer_in',
                    'assets.transfer_out',
                    'assets.fee',
                    'assets.rebate',
                    'assets.mining',
                    'assets.activity',
                    'assets.peer_to_peer_freeze',
                    'assets.peer_to_peer_return'
                ];
            } else if (this.account === 2) { // 现货账户
                this.genre = [
                    'assets.all',
                    'assets.trade',
                    'assets.fee',
                    'assets.transfer_in',
                    'assets.transfer_out'
                ];
            } else if (this.account === 3) { // 合约账户
                this.genre = [
                    'assets.all',
                    'assets.open_position',
                    'assets.close_position',
                    'assets.fee',
                    'assets.pnl',
                    'assets.transfer_in',
                    'assets.transfer_out'
                ];
            } else { // 其他账户
                this.genre = [
                    'assets.all',
                    'assets.deposit',
                    'assets.withdraw',
                    'assets.transfer_in',
                    'assets.transfer_out'
                ];
            }
            
            this.stateOption = [
                'assets.all_status', 
                'assets.pending', 
                'assets.completed', 
                'assets.expired'
            ];
            this.coinList = [
                'assets.all_coins', 
                'USDT', 'BTC', 'ETH', 'LTC', 'BCH', 'BNB', 'LINK'
            ];
            
            this.selectedType = this.$t('assets.all');
            this.selectedCurrency = this.$t('assets.all_coins');
            this.selectedStatus = this.$t('assets.all_status');
        },
        
        paginate(_page){
            page = _page;
            this.getLogList();
        },
        reset(){
            this.start_at = "";
            this.end_at = "";
            this.selectedType = this.$t('assets.all');
            this.selectedCurrency = this.$t('assets.all_coins');
            this.selectedStatus = this.$t('assets.all_status');
            this.type = 0;
            this.currency_id = 0;
            page = 1;
            this.timeValue = [];
            
            // 重新初始化选项
            this.initializeOptions();
            
            this.getLogList();
        },
        getLogList(){
            userApi.getCpitalFlow({
                account:this.account,
                start_at:this.start_at,
                end_at:this.end_at,
                currency_id:this.currency_id,
                type:this.type,
                page:page
            }).then(res=>{
                console.log("资金流水API响应:", res);
                this.logList = res.data.list || [];
                this.total = res.data.total || 0;
                
                // 处理类型映射
                if (res.data.types && Array.isArray(res.data.types)) {
                    const typeMap = {};
                    res.data.types.forEach(type => {
                        if (type.value !== undefined && type.label !== undefined) {
                            typeMap[type.value] = type.label;
                        }
                    });
                    this.types = typeMap;
                } else {
                    this.types = res.data.type || {};
                }
                
                // 添加C2C类型映射
                this.types[57] = this.$t('assets.peer_to_peer_freeze');
                this.types[58] = this.$t('assets.peer_to_peer_return');
            }).catch(error => {
                console.error("获取资金流水失败:", error);
                this.logList = [];
                this.total = 0;
                this.types = {};
            })
        },
        tabChange(key){
            this.account = parseInt(key);
            page = 1;
            console.log("切换到账户:", this.account);
            
            // 重新初始化选项
            this.initializeOptions();
            
            // 重置筛选条件
            this.selectedType = this.$t('assets.all');
            this.selectedCurrency = this.$t('assets.all_coins');
            this.selectedStatus = this.$t('assets.all_status');
            this.type = 0;
            
            this.getLogList();
        },
        handleSelect(value){
            console.log("选择的值:", value);
            
            // 根据当前选中的类型更新相应的变量
            if (this.genre.includes(value)) {
                this.selectedType = this.$t(value);
                // 根据选择的类型设置对应的type值
                if (value === 'assets.all') {
                    this.type = 0;
                } else if (value === 'assets.deposit') {
                    this.type = 19; // 充值
                } else if (value === 'assets.withdraw') {
                    this.type = 27; // 提现
                } else if (value === 'assets.transfer_in') {
                    this.type = 1; // 划入
                } else if (value === 'assets.transfer_out') {
                    this.type = 2; // 划出
                } else if (value === 'assets.fee') {
                    this.type = 14; // 手续费
                } else if (value === 'assets.rebate') {
                    this.type = 28; // 返佣
                } else if (value === 'assets.mining') {
                    this.type = 46; // 挖矿
                } else if (value === 'assets.activity') {
                    this.type = 50; // 活动
                } else if (value === 'assets.trade') {
                    this.type = 3; // 交易
                } else if (value === 'assets.open_position') {
                    this.type = 6; // 开仓手续费
                } else if (value === 'assets.close_position') {
                    this.type = 7; // 平仓手续费
                } else if (value === 'assets.pnl') {
                    this.type = 8; // 盈亏
                } else if (value === 'assets.peer_to_peer_freeze') {
                    this.type = 57; // C2C冻结
                } else if (value === 'assets.peer_to_peer_return') {
                    this.type = 58; // C2C退回
                } else {
                    this.type = 0; // 默认全部
                }
                console.log("设置type为:", this.type);
            } else if (this.stateOption.includes(value)) {
                this.selectedStatus = this.$t(value);
            } else if (this.coinList.includes(value)) {
                this.selectedCurrency = value === 'assets.all_coins' ? this.$t(value) : value;
                // 设置币种ID
                if (value === 'assets.all_coins') {
                    this.currency_id = 0;
                } else {
                    // 这里需要根据币种符号设置对应的ID
                    // 暂时设置为0，实际应该根据币种映射设置
                    this.currency_id = 0;
                }
            }
            
            // 重新获取数据
            page = 1;
            this.getLogList();
        },
        openModalDetail(item){
            this.modalShow = true;
        },
        onChange(dateString, date) {
            if (date && date.length === 2) {
                this.start_at = date[0];
                this.end_at = date[1];
                console.log("时间范围:", this.start_at, "到", this.end_at);
                page = 1;
                this.getLogList();
            }
        },
        onSelect(dateString, date) {
            if (date && date.length === 2) {
                this.start_at = date[0];
                this.end_at = date[1];
                console.log("选择时间范围:", this.start_at, "到", this.end_at);
            }
        },
        // 格式化数字，去除无意义的尾随零
        formatNumber(value) {
            if (!value || parseFloat(value) === 0) {
                return '0.00';
            }
            const num = parseFloat(value);
            // 去除末尾的0，但保留至少2位小数
            return num.toFixed(8).replace(/\.?0+$/, '').replace(/^(\d+\.\d{1})$/, '$10');
        }
    }
}